import React, { useMemo } from "react";
import styles from "./game.module.css";
import GreenHeader from "../components/GreenHeader";

function Game({ name, round, levelRound, id, children, headq }) {

  const words = useMemo(() => {
    if (id === "3" || id === "4") {
      return name;
    } else {
      return `${name} : ${round + 1} /${levelRound}`;
    }
  }, [id,name,round,levelRound]);

  return (
    <div>
      <GreenHeader word={words} />
      <div className={styles.body}>
        {headq && (
          <div className={styles.head}>
            <div className={styles.headtext}>
              {id === "6" ? `เลือกภาพที่เป็น${headq}เดียวกัน` : headq}
            </div>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}

export const QuestionPicture = ({ pic }) => (
  <img className={styles.question} src={pic} alt={pic} />
);

export default Game;
